// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","desktop_only":"(min-width: 1024px)","quickSearchForm":"quickSearchForm-2Ye_X"};